import { createFileRoute } from "@tanstack/react-router";
import { PermissionManagementPage } from "@client/components/admin/permission-management/permission-management-page";

export const Route = createFileRoute("/_app/tenant-settings/permissions")({
  component: PermissionManagementRoutePage,
});

function PermissionManagementRoutePage() {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <PermissionManagementPage />
    </div>
  );
}
